import { render, staticRenderFns } from "./editHeader.vue?vue&type=template&id=bbf747e2&"
import script from "./editHeader.vue?vue&type=script&lang=js&"
export * from "./editHeader.vue?vue&type=script&lang=js&"
import style0 from "./editHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports